import { render } from "./regulatory_calendar.html?vue&type=template&id=fa1f32c2&external"
import script from "./regulatory_calendar.js?vue&type=script&lang=js&external"
export * from "./regulatory_calendar.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__